// TRIDENT-896: soft rollout — mirror utm_* → internal_* on internalreferral
// traffic without deleting utm_*. CLEANUP-AFTER-SOAK: re-add params.delete(utmKey)
// below. See dynamic-app/docs/TRIDENT-896-cleanup.md.
const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_id',
  'utm_name',
] as const;

const INTERNAL_REFERRAL_MEDIUM = 'internalreferral';

export function rewriteInternalReferralParams(): void {
  if (typeof window === 'undefined' || !window.location) return;

  const params = new URLSearchParams(window.location.search);
  if (params.get('utm_medium') !== INTERNAL_REFERRAL_MEDIUM) return;

  let changed = false;
  UTM_KEYS.forEach((utmKey) => {
    const value = params.get(utmKey);
    if (value === null) return;
    const internalKey = utmKey.replace(/^utm_/, 'internal_');
    // SOFT-ROLLOUT-DELETE: re-add `params.delete(utmKey);` here on cleanup.
    params.set(internalKey, value);
    changed = true;
  });

  if (!changed) return;

  const search = params.toString();
  const newUrl = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;
  window.history.replaceState(window.history.state, '', newUrl);
}
